import { render, staticRenderFns } from "./PoliciesAndTemplatesForm.vue?vue&type=template&id=58619d4b&scoped=true&"
import script from "./PoliciesAndTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./PoliciesAndTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesAndTemplatesForm.vue?vue&type=style&index=0&id=58619d4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58619d4b",
  null
  
)

export default component.exports